import { render, staticRenderFns } from "./tabCrmCustomerBussiness.vue?vue&type=template&id=44b22dd4&scoped=true&"
import script from "./tabCrmCustomerBussiness.vue?vue&type=script&lang=js&"
export * from "./tabCrmCustomerBussiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b22dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b22dd4')) {
      api.createRecord('44b22dd4', component.options)
    } else {
      api.reload('44b22dd4', component.options)
    }
    module.hot.accept("./tabCrmCustomerBussiness.vue?vue&type=template&id=44b22dd4&scoped=true&", function () {
      api.rerender('44b22dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/crm/tabs/tabCrmCustomerBussiness.vue"
export default component.exports